import { stats } from "@/mocks/comicData";

export default function Intro() {
  return (
    <section id="intro" className="relative overflow-hidden bg-background-100 py-16 md:py-24">
      <div className="absolute inset-0 halftone opacity-60" />
      <div className="relative mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
              <i className="ri-archive-line" />
              平台介绍
            </span>
            <h2 className="font-heading mt-4 text-3xl leading-tight text-foreground-950 md:text-4xl">
              关于虚空漫画网
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              虚空漫画网是一个专注于漫画阅读的平台，汇集热血、奇幻、都市、悬疑、恋爱、科幻、穿越与搞笑等十余个热门品类，漫画总量超过一万部，且保持每日更新。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              站内提供书架收藏、追更提醒、浏览记录与多端同步等功能，无需安装任何软件，在浏览器中打开对应入口即可随时随地开始阅读。
            </p>

            <ul className="mt-6 space-y-3 text-sm text-foreground-700 md:text-base">
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-line mt-0.5 text-lg text-primary-600" />
                <span>涵盖热血、恋爱、科幻等全品类，满足不同口味</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-line mt-0.5 text-lg text-accent-600" />
                <span>多入口多终端访问，页面打不开时总有替代通道</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-line mt-0.5 text-lg text-secondary-600" />
                <span>书架、追更、历史记录一键同步，续读无缝衔接</span>
              </li>
            </ul>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {stats.map((item, idx) => (
              <div
                key={item.label}
                className={`rounded-lg border bg-background-50 p-6 text-center md:p-8 ${
                  idx % 3 === 0
                    ? "border-primary-200"
                    : idx % 3 === 1
                      ? "border-accent-200"
                      : "border-secondary-200"
                }`}
              >
                <p
                  className={`font-heading text-3xl font-bold md:text-4xl ${
                    idx % 3 === 0
                      ? "text-primary-700"
                      : idx % 3 === 1
                        ? "text-accent-700"
                        : "text-secondary-700"
                  }`}
                >
                  {item.value}
                </p>
                <p className="mt-2 text-xs text-foreground-600 md:text-sm">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}